import PropTypes from 'prop-types';
import RequestSentIcon from '../icons/RequestSentIcon';
import { makeCancelable, validateUsername } from '../utils/utils';
import { Typography } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BasicBackground from '../BasicBackground';
import Errored from '../Errored';
import { authenticationService } from '../services/security/authenticationService';
import { globalStyles } from '../style/gstheme';
import { MAX_USERNAME_LENGTH } from '../utils/constants';
import AccessHeader from './AccessHeader';

const styles = () => {
    return Object.assign({
        forgotten: {
            textAlign: 'center',
            height: '560px',
            position: 'fixed',
            top: 'calc(50% - 280px)',
            left: 'calc(50% - 192px)',
            width: 384,
            padding: 20,
            borderRadius: 5,
            backgroundColor: 'white',
        }
    }, globalStyles);
};

class ForgottenPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            isErrored: null,
            processing: false,
            completed: false
        };
        this.cancellable = null;
        this.textInput = React.createRef();
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    submit = async () => {
        this.setState({ processing: true }, async () => {
            try {
                const { username } = this.state;
                await this.doForgotten(username).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({
                    completed: true,
                    processing: false
                });
            }
            catch (e) {
                const message = [429].includes(e.status) ?
                    e.message
                    :
                    "We cannot process your request at the moment. Please try again later.";
                this.setState({
                    isErrored: { message },
                    processing: false
                });
            }
        });
    };

    doForgotten(username) {
        this.cancellable = makeCancelable(authenticationService.forgottenPassword(username));
        return this.cancellable;
    }

    clearError = () => {
        this.setState({ isErrored: null }, () => this.textInput && this.textInput.current && this.textInput.current.focus());
    };

    handleChange = (event) => {
        const t = event.target;
        this.setState({ [t.name]: t.value });
    };

    render() {

        const { username, isErrored, processing, completed } = this.state;
        const { classes } = this.props;
        const validUsername = validateUsername(username);
        const disabled = username.length < 3 || processing || !validUsername;

        return (
            <BasicBackground>
                <Grid container spacing={0} direction="row" className={classes.forgotten} >
                    <Grid item xs={12}>
                        <AccessHeader title="Forgotten Password" />
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.loginEntry}>
                            <Typography className={classes.loginSubHeading}>Username</Typography>
                            <TextField className={classes.loginText}
                                FormHelperTextProps={{
                                    "data-test": "username-helper-text"
                                }}
                                data-test="username"
                                autoComplete="username"
                                margin="dense"
                                disabled={completed}
                                id="username"
                                name="username"
                                error={username.length > 0 && !validUsername}
                                helperText={username.length > 0 && !validUsername && "This is not a valid username."}
                                value={username}
                                inputRef={this.textInput}
                                autoFocus={true}
                                variant="outlined"
                                placeholder="Username"
                                fullWidth
                                onKeyPress={(ev) => {
                                    if (!disabled && ev.charCode === 13) {
                                        this.submit();
                                        ev.preventDefault();
                                        ev.stopPropagation();
                                    }
                                }}
                                onChange={this.handleChange}
                                InputProps={{
                                    className: classes.loginInput,
                                    inputProps: {
                                        className: classes.loginInput,
                                        maxLength: MAX_USERNAME_LENGTH
                                    }
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        {completed ?
                            <div>
                                <div style={{ marginBottom: '12px' }}>
                                    <RequestSentIcon style={{ width: '36px', height: '32px' }} />
                                </div>
                                <Typography paragraph variant="h3" className={classes.mainHeadingSecondary}>Reset Information Sent</Typography>
                            </div>
                            :
                            <Typography variant="body2">Reset information will be sent to the email address associated with this username.</Typography>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        {completed ?
                            <Typography data-test="instructions" variant="body2">Please check your email.</Typography>
                            :
                            <Fab
                                data-test="send"
                                disabled={disabled}
                                variant="extended"
                                color="secondary"
                                className={classes.button}
                                style={{ width: '120px' }}
                                onClick={() => this.submit()}>Send</Fab>
                        }
                    </Grid>
                </Grid>
                {isErrored && <Errored data={isErrored} clearError={this.clearError} />}
            </BasicBackground>
        );
    }
}

ForgottenPassword.propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(withStyles(styles)(ForgottenPassword));